import { Field } from 'formik';
import styled from 'styled-components/macro';

export const RadioBtn = styled.span<{ disabled?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;

  width: 1rem;
  height: 1rem;

  border: 1px solid
    ${({ theme, disabled }) => (disabled ? theme.colors.black_40 : theme.colors.black_60)};
  border-radius: 50%;

  background-color: ${({ theme }) => theme.colors.white};

  cursor: pointer;

  &:after {
    position: absolute;

    display: none;

    content: '';
  }
`;

export const RadioButtonWrapper = styled.label<{ disabled?: boolean }>`
  position: relative;

  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing.zero_3};
  padding-left: ${({ theme }) => theme.spacing.one_2};

  color: ${({ theme, disabled }) => (disabled ? theme.colors.black_40 : theme.colors.black_100)};
  font-size: ${({ theme }) => theme.fontSize.xs};

  cursor: pointer;

  ${RadioBtn} {
    &:after {
      top: 50%;
      left: 50%;

      width: 0.625rem;
      height: 0.625rem;
      border-radius: 50%;

      background-color: ${({ theme }) => theme.colors.primary};
      transform: translate(-50%, -50%);
    }
  }
`;

export const Input = styled(Field)`
  position: absolute;

  opacity: 0;
  &:checked ~ ${RadioBtn} {
    border: 1px solid ${({ theme }) => theme.colors.primary};

    &:after {
      display: block;
    }
  }
`;

export const RadioBtnTitle = styled.label`
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme }) => theme.colors.black_60};
  font-size: ${({ theme }) => theme.fontSize.xxs};
`;
